/**
 * driverArchive — shared snapshot builder for the `firedDriversArchive`.
 *
 * 13/06/2026 — Bug fix « employé réembauché perd ses formations » :
 * certains chemins de départ (départ négocié 31/12 pour pression congés,
 * démission suite à grève) supprimaient le chauffeur SANS l'archiver.
 * Au ré-embauchage, `hireDriver` ne trouvait pas d'archive → formations,
 * niveau et permis perdus. Tous les chemins de départ passent désormais
 * par ce helper (même shape que fireDriver / rollMonthlyAttrition).
 */
export function buildDriverArchiveEntry(driver, totalDays = 0) {
  return {
    level: driver.level,
    xp: driver.xp,
    specialty: driver.specialty,
    specialty2: driver.specialty2,
    extraSpecialties: driver.extraSpecialties || [],
    licenses: driver.licenses,
    competence: driver.competence,
    accidentRisk: driver.accidentRisk,
    // 08/02/2026 — Q2 Future/Backlog : la fiche d'archive stocke désormais
    // le salaire brut en plus du coût employeur. Réutilisé par hireDriver
    // pour appliquer la prime de réembauche (+5 %, voir REHIRE_PREMIUM).
    salaryGross: driver.salaryGross,
    employerCost: driver.employerCost,
    trainings: driver.trainings || [],
    totalTrips: driver.totalTrips || 0,
    totalKm: driver.totalKm || 0,
    firedAt: totalDays,
  };
}

// 08/02/2026 — Prime de réembauche d'un ancien chauffeur.
// Justification narrative : l'ex-employé sait qu'il était parti, revient en
// position de force et négocie une légère hausse de marché. Documenté
// dans FormerDriversTab (UI) et hrSlice.hireDriver (logique).
export const REHIRE_PREMIUM = 1.05; // +5 % sur le dernier salaire connu
